import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-cookies';
import 'angular-i18n/angular-locale_de-ch';
import 'angular-messages';
import 'angular-moment';
import 'angular-recaptcha';
import 'angular-sanitize';
import 'angular-smart-table';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'angular-ui-bootstrap';
import 'angular-unsavedchanges';
import 'angular-utf8-base64';
import 'ng-file-upload';
import 'ng-map-autocomplete';
import 'ngmap';
import 'raven-js';
import 'raven-js/plugins/angular';
import 'ui-select';



// WEBPACK FOOTER //
// ./src/vendor.ts